const namedEntities = {
	amp: '&',
	apos: "'",
	gt: '>',
	lt: '<',
	quot: '"',
}

export function decodeHtmlEntities(value = '') {
	return value.replace(/&(#(?:x[\da-f]+|\d+)|[a-z][\da-z]+);/gi, (entity, code) => {
		if (code[0] === '#') {
			const isHex = code[1].toLowerCase() === 'x'
			const number = Number.parseInt(code.slice(isHex ? 2 : 1), isHex ? 16 : 10)

			return Number.isNaN(number) ? entity : String.fromCodePoint(number)
		}

		return namedEntities[code.toLowerCase()] || entity
	})
}